import React from "react";
import Footer from "../components/Footer";
import ProjectSlides from "../components/ProjectSlides";
import { Helmet } from "react-helmet";

export default function Projects() {
    return (
        <>
        <Helmet>
            <title>Projects | John Mangahis</title>
        </Helmet>
        <div className="main-heading-container no-subheading">
            <p className="heading-small-caption">Check out some of the things I've made!</p>
            <h1>Projects</h1>
        </div>
        <section className="project-container">
            <h2>Bubble CiTea</h2>
            <ProjectSlides project={"bct"}/>
        </section>
        <section className="project-container">
            <h2>Mirage Technology</h2>
            <ProjectSlides project={"mirage"}/>
        </section>
        <section className="project-container">
            <h2>Company directory</h2>
            <ProjectSlides project={"directory"}/>
        </section>
        <section className="project-container">
            <h2>Gazetteer</h2>
            <ProjectSlides project={"gazetteer"}/>
        </section>
        <div className="footnotes-container">
            <p className="disclaimer style-italics"><sup>†</sup>Subject to availability; APIs do not currently support all cities. See <a className="hover-underline" href="https://api.windy.com">WindyAPI</a>, <a className="hover-underline" href="https://newsapi.org">NewsAPI</a>, <a className="hover-underline" href="https://openweathermap.org">OpenWeatherMap</a> for more information.</p>
        </div>
        <Footer/>
        </>
    )
}